import { render, staticRenderFns } from "./settings-organization-groups.vue?vue&type=template&id=abec5738&scoped=true&"
import script from "./settings-organization-groups.vue?vue&type=script&lang=js&"
export * from "./settings-organization-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abec5738",
  null
  
)

export default component.exports